export const DEFAULT_ERRORS_CLASSNAME =
  'input__box-validation-message input__box-validation-message--error show';
